import React, { useEffect, Suspense, useMemo } from "react"; // ← Added useMemo
import Decoder from "jwt-decode";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import { routes } from "./routes";
import Signin from "./user/Signin";
import Dashboard from "./pages/Dashboard/Dashboard";
import NotAuthorized from "./pages/NotAuthorized";
import NotFound from "./pages/NotFound";
import LoadingSpinner from "./core/LoadingSpinner";
import './components/delivery/delivery.css';

import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // OPTIMIZED: Memoize menu parsing - only runs when userInfo changes
  const decodeMenuInPlainListTokenData = useMemo(() => {
    if (!userInfo?.menuInPlainListToken) return null;
    
    try {
      const decoded = Decoder(userInfo.menuInPlainListToken);
      return JSON.parse(decoded.UserMenuPlainList);
    } catch (error) {
      console.error("Menu parse error:", error);
      return null;
    }
  }, [userInfo]);

  // OPTIMIZED: Create route map once - O(1) lookups instead of .find()
  const routeMap = useMemo(() => {
    const map = new Map();
    routes.forEach((route) => {
      map.set(route.path, route);
    });
    return map;
  }, []); // Only runs once on mount

  // OPTIMIZED: Generate dynamic routes only when menus change
  const dynamicRoutes = useMemo(() => {
    if (!decodeMenuInPlainListTokenData) return [];
    
    return decodeMenuInPlainListTokenData
      .map((menu) => {
        const matchedRoute = routeMap.get(menu.MenuURL); // O(1) lookup instead of .find()
        
        return matchedRoute ? (
          <Route
            key={matchedRoute.path}
            path={matchedRoute.path}
            component={matchedRoute.component}
            exact
          />
        ) : null;
      })
      .filter(Boolean); // Remove nulls
  }, [decodeMenuInPlainListTokenData, routeMap]);

  useEffect(() => {
    document.body.style.zoom = "95%";
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Switch>
          <Route path="/signin" component={Signin} exact />
          <Route path="/" component={Dashboard} exact />
          <Route path="/dashboard" component={Dashboard} exact />
          
          {/* OPTIMIZED: Pre-computed dynamic routes */}
          {dynamicRoutes}

          <Route component={NotAuthorized} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;